import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StringHash } from '@app/shared/utils/utils-types';
import { LocalStorageKeys } from '@app/services/local-storage.service';

@Component({
  standalone: false,
  selector: 'ti-errors-grid-modal',
  templateUrl: 'errors-grid-modal.component.html',
  styleUrls: ['errors-grid-modal.component.sass'],
})
export class ErrorsGridDialogComponent<T extends StringHash<any> = StringHash<any>> {
  readonly localStorageKeys = LocalStorageKeys;
  readonly strings = tiStrings.app.misc;

  @Input() title: string;
  @Input() comment: string;
  @Input() showCheckboxes: boolean = false;
  @Input() showPostProcessButton: boolean = false;
  @Input() columns: { name: string; title: string; width?: number }[];
  @Input() data: T[];
  @Output() close = new EventEmitter<{ cancel: boolean }>();
  @Output() postProcess = new EventEmitter();
  @Input() processButtonTitle: string;
  @Input() closeButtonTitle: string = this.strings.ok;
  @Input() processButtonDisabled: boolean = false;
  public selectedKeys: any[] = [];
  processCallback: (res: any) => void;

  onClose() {
    this.close.emit();
  }

  onPostProcess() {
    const noErrors = this.selectedKeys && this.selectedKeys.length;
    if (noErrors || !this.showCheckboxes) {
      this.postProcess.emit(this.selectedKeys);
      this.close.emit({ cancel: false });
    } else {
      // this.close.emit({cancel: true});
    }
  }
}
